import { format } from "date-fns";

function fixHours( hours, suffix ) {
	if ( suffix === "pm" && hours !== 12 ) {
		hours += 12;
	} else if ( suffix === "am" && hours === 12 ) {
		hours -= 12;
	}

	return hours;
}

export default function( time, token = "h:mm a" ) {
	if ( !time ) {
		return null;
	}

	if ( typeof time === "string" ) {
		time = time.toLowerCase();
	}

	let dateTime = new Date( time );

	if ( Number.isNaN( dateTime.valueOf() ) ) {
		const parsedTime = time.match( /(\d+)(?::(\d\d))?\s*([ap]?[m]?)/ );

		if ( parsedTime && parsedTime.length === 4 ) {
			dateTime = new Date();

			const suffix = parsedTime[3];
			const hours = fixHours( parseInt( parsedTime[1] ), suffix );
			const minutes = parseInt( parsedTime[2] ) || 0;

			dateTime.setHours( hours );
			dateTime.setMinutes( minutes );
			dateTime.setSeconds( 0 );
		}
	}

	const formattedTime = format( dateTime, token );

	if ( formattedTime === "Invalid Date" ) {
		return time;
	}

	return formattedTime;
}
